import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/primitives";
import { RequirePermission } from "@/features/auth/RequirePermission";
import { NewTicketDialog } from "@/features/tickets/NewTicketDialog";

/** Raise-a-ticket button + dialog, for the customer portal. */
export function NewTicketButton() {
  const [open, setOpen] = useState(false);
  return (
    <RequirePermission permission="ticket:create">
      <Button onClick={() => setOpen(true)}>
        <Plus className="h-4 w-4" aria-hidden="true" />
        New request
      </Button>
      <NewTicketDialog open={open} onClose={() => setOpen(false)} />
    </RequirePermission>
  );
}
